const urlParamKeys = {
  discountCode: 'discountcode',
  paymentPeriodId: 'paymentperiodid',
} as const

export default urlParamKeys
